"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RTTI_MedicinalProductAuthorization = void 0;
var t = __importStar(require("io-ts"));
var RTTI_id_1 = require("../Scalar/RTTI_id");
var RTTI_Meta_1 = require("./RTTI_Meta");
var RTTI_uri_1 = require("../Scalar/RTTI_uri");
var RTTI_Element_1 = require("./RTTI_Element");
var RTTI_code_1 = require("../Scalar/RTTI_code");
var RTTI_Narrative_1 = require("./RTTI_Narrative");
var RTTI_ResourceList_1 = require("../Union/RTTI_ResourceList");
var RTTI_Extension_1 = require("./RTTI_Extension");
var RTTI_Identifier_1 = require("./RTTI_Identifier");
var RTTI_Reference_1 = require("./RTTI_Reference");
var RTTI_CodeableConcept_1 = require("./RTTI_CodeableConcept");
var RTTI_dateTime_1 = require("../Scalar/RTTI_dateTime");
var RTTI_Period_1 = require("./RTTI_Period");
var RTTI_MedicinalProductAuthorization_JurisdictionalAuthorization_1 = require("./RTTI_MedicinalProductAuthorization_JurisdictionalAuthorization");
var RTTI_MedicinalProductAuthorization_Procedure_1 = require("./RTTI_MedicinalProductAuthorization_Procedure");
exports.RTTI_MedicinalProductAuthorization = t.recursion('IMedicinalProductAuthorization', function () {
    return t.intersection([
        t.type({
            resourceType: t.literal('MedicinalProductAuthorization')
        }),
        t.partial({
            id: RTTI_id_1.RTTI_id,
            meta: RTTI_Meta_1.RTTI_Meta,
            implicitRules: RTTI_uri_1.RTTI_uri,
            _implicitRules: RTTI_Element_1.RTTI_Element,
            language: RTTI_code_1.RTTI_code,
            _language: RTTI_Element_1.RTTI_Element,
            text: RTTI_Narrative_1.RTTI_Narrative,
            contained: t.array(RTTI_ResourceList_1.RTTI_ResourceList),
            extension: t.array(RTTI_Extension_1.RTTI_Extension),
            modifierExtension: t.array(RTTI_Extension_1.RTTI_Extension),
            identifier: t.array(RTTI_Identifier_1.RTTI_Identifier),
            subject: RTTI_Reference_1.RTTI_Reference,
            country: t.array(RTTI_CodeableConcept_1.RTTI_CodeableConcept),
            jurisdiction: t.array(RTTI_CodeableConcept_1.RTTI_CodeableConcept),
            status: RTTI_CodeableConcept_1.RTTI_CodeableConcept,
            statusDate: RTTI_dateTime_1.RTTI_dateTime,
            _statusDate: RTTI_Element_1.RTTI_Element,
            restoreDate: RTTI_dateTime_1.RTTI_dateTime,
            _restoreDate: RTTI_Element_1.RTTI_Element,
            validityPeriod: RTTI_Period_1.RTTI_Period,
            dataExclusivityPeriod: RTTI_Period_1.RTTI_Period,
            dateOfFirstAuthorization: RTTI_dateTime_1.RTTI_dateTime,
            _dateOfFirstAuthorization: RTTI_Element_1.RTTI_Element,
            internationalBirthDate: RTTI_dateTime_1.RTTI_dateTime,
            _internationalBirthDate: RTTI_Element_1.RTTI_Element,
            legalBasis: RTTI_CodeableConcept_1.RTTI_CodeableConcept,
            jurisdictionalAuthorization: t.array(RTTI_MedicinalProductAuthorization_JurisdictionalAuthorization_1.RTTI_MedicinalProductAuthorization_JurisdictionalAuthorization),
            holder: RTTI_Reference_1.RTTI_Reference,
            regulator: RTTI_Reference_1.RTTI_Reference,
            procedure: RTTI_MedicinalProductAuthorization_Procedure_1.RTTI_MedicinalProductAuthorization_Procedure
        })
    ]);
});
//# sourceMappingURL=RTTI_MedicinalProductAuthorization.js.map